export class Tenant {
  constructor(
    public Id: number,
    public readonly Nombre: string | null,
    public readonly NombreCorto: string | null,
    public readonly NroDocumento: string | null,
    public readonly TipoResponsableIvaId: number | null,
    public readonly NumeroMatriculaRpa: string | null,
    public readonly Direccion: string | null,
    public readonly Telefono: string | null,
    public readonly Email: string | null,
    public readonly SitioWeb: string | null,
    public readonly LogoUrl: string | null,
    public readonly Activo: boolean,
    public FeatureFlags: FeatureFlag[]
  ) {}
}

export class SearchTenantRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Nombre: string | null,
    public readonly NroDocumento: string | null,
    public readonly UsuarioId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveTenantDto {
  constructor(
    public Id: number,
    public Nombre: string | null,
    public NombreCorto: string | null,
    public NroDocumento: string | null,
    public TipoResponsableIvaId: number | null,
    public NumeroMatriculaRpa: string | null,
    public Direccion: string | null,
    public Telefono: string | null,
    public Email: string | null,
    public SitioWeb: string | null,
    public FotoLogoBase64: string | null,
    public FotoLogoExtension: string | null,
    public Activo: boolean,
    public FeatureFlags: number[]
  ) {}
}

export class SearchTenantResponse {
  constructor(
    public readonly count: number,
    public readonly result: Tenant[]
  ) {}
}

export class TenantDiccionarioDto {
  constructor( 
      public readonly Id: string | null, 
      public readonly TenantId: number,
      public readonly TenantNombre: string | null, 
      public Key: string | null, 
      public NombreMostrar: string
  ){}
}

export class TenantFeatureFlags {
  constructor(
    public TenantId: number,
    public HabilitarGestionConsorcio: boolean,
    public HabilitarGestionObra: boolean,
    public HabilitarGestionUf: boolean,
    public HabilitarControlGastos: boolean,
    public HabilitarControlExpensas: boolean,
    public HabilitarControlPedidos: boolean,
    public HabilitarControlCaja: boolean,
    public HabilitarFacturacion: boolean,
    public HabilitarLiquidacionSueldos: boolean,
    public HabilitarControlContratos: boolean
  ) {}
}

export class FeatureFlag {
  constructor(
    public Id: number,
    public Nombre: string
  ) {}
}

export enum TenantEnum {
  Rosbaco = 1,
  ZbConstructora = 3
}